import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';

interface getPpmHistoryDataTableStructureProps {
  store: any;
  rowActions?: DataTableRowActions;
}

export const getPpmHistoryPVDataTableStructure = ({ store, rowActions }: getPpmHistoryDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.ref',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'Commission',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'Historique PV',
    plural: 'ppm.plural_history',
    data: [],
    columns: [refColumn, nomColumn, statusColumn, createdAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => store.setState(row),
    rowActions,
    searchableFields: ['ref', 'nom', 'annee', 'status'],
  };
};
